export enum TWILIO_STATUS {
  APPROVED = 'APPROVED',
  INCOMPLETE = 'INCOMPLETE',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN',
  NOTFOUND = 'NOTFOUND',
}
